import React, {useState} from 'react';
import styles from './styles';
import { trackActivity } from '../../../utils/activityTracker'
import { UserContext } from '../../../Context/UserContext'
import { InstanceContext } from '../../../InstanceContext'

const ToolbarButton = props => {

  const [hover, setHover] = useState(false);
  // const [focus, setFocus] = useState(false);
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  const action = () => {
    // console.log(props.text.replace(/ /g, '%20'), "TEXT")
    props.changeParam(props.text.replace(/ /g, '%20'))
    // handleActivityLogUpdate(`ToolbarButton.action`)
  }
  const buttonStyleKey = props.active ? 'buttonAct' : 'button';

  const hoverOn = () => setHover(true);
  const hoverOff = () => setHover(false);
  // const focusOn = () => setFocus(true);
  // const focusOff = () => setFocus(false);

  let buttonStyles = {
      ...styles.button,
      ...styles[buttonStyleKey],
      width: props.width,
      zIndex: props.active ? props.zMax : props.zIndex,
      marginLeft: props.first ? 0 : styles.button.marginLeft
    }
  if (hover && !props.active) buttonStyles = {...buttonStyles, ...styles.buttonHov};

  const isUserAgentIE = () => {
    //Check the userAgent property of the window.navigator
    // UA here is used for User Agent
    const UA = window.navigator.userAgent;
    // check if IE 10 or older
    const msie = UA.indexOf('MSIE ');
      // check if IE 11
    const trident = UA.indexOf('Trident/');
    return (msie > 0 || trident > 0);
  }

  const activeEdge = (styles) => {
    let style;
    if (isUserAgentIE()) {
      style = {...styles.buttonEdge, width: '8%', right: '-2px'}
    } else {
      style = {...styles.buttonEdge}
    }
    return style
  }

  return(
    <button style={buttonStyles}
      onClick={action}
      onMouseEnter={hoverOn}
      onMouseLeave={hoverOff}
    >
      <span style={props.active ? {...styles.buttonWrap, ...styles.buttonWrapActive} : styles.buttonWrap}>
        <span style={styles.buttonText}>{props.text}</span>
      </span>
      <span style={props.active ? {...activeEdge(styles), ...styles.buttonEdgeActive} : activeEdge(styles)}>
        <svg style={props.last
          ? {
            ...styles.buttonEdgeSvg,
            width: '100%',
            height: '100%',
          }
          : styles.buttonEdgeSvg
        }
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14.32 36"
        preserveAspectRatio={props.last ? 'none' : 'xMinYMin'}>
          <defs xmlns="http://www.w3.org/2000/svg">
            <filter id="dropshadow" height="130%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
              <feOffset dx="2" dy="2" result="offsetblur"/>
              <feComponentTransfer>
                <feFuncA type="linear" slope="0.3"/>
              </feComponentTransfer>
              <feMerge>
                <feMergeNode/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          <path
            style={props.last ? {width: '100%', height: '100%'} : null}
            filter={props.last ? null : 'url(#dropshadow)'}
            d="M8,16l6.32,20H0V0C1,0,2,1,3,2,5,4,6.33,11,8,16Z"/>
        </svg>
      </span>
    </button>

  )
}


export default ToolbarButton;

    // <Button
    //   onClick={action}
    //   styles={{
    //     ...styles.button,
    //     ...styles[buttonStyleKey],
    //     width: props.width,
    //     borderRight: props.last ? 'none' : styles.button.borderRight,
    //   }}
    //   hoverStyles={styles[(buttonStyleKey + 'Hov')]}
    //   activeStyles={styles.buttonAct}
    // >
    //   <span style={styles.buttonText}>{props.text}</span>
    // </Button>
